import React, { useContext, useEffect, useState } from "react";
import { ConfigContext } from "./index";
function Actions(props) {
    const { config, setState, translation } = useContext(ConfigContext);
    const { state, submitButtonRef, } = props;
    const [customClasses, setCustomClasses] = useState();
    const [useCustomClasses, setUseCustomClasses] = useState(false);
    useEffect(() => {
        if (config.useCustomClasses) {
            setUseCustomClasses(true);
            setCustomClasses({ ...config.customClasses.candidateWidget });
        }
    }, []);
    const setButtonLabel = () => {
        switch (state) {
            case "register":
                return translation.candidateWidgetRegisterSubmit;
            case "recover":
                return translation.candidateWidgetRecoverSubmit;
            case "login":
                return translation.candidateWidgetLoginSubmit;
            case "loggedin":
                return null;
            default:
                return null;
        }
    };
    const handleCustomClass = (name) => {
        console.log("name", name);
        if (useCustomClasses === false) {
            return "";
        }
        if (customClasses[name] === undefined) {
            return "";
        }
        return customClasses[name];
    };
    const menuLinks = () => {
        switch (state) {
            case "register":
                return (React.createElement(React.Fragment, null,
                    translation.candidateWidgetAlredySignedUp,
                    " ",
                    React.createElement("a", { className: "tms-candidate-widget-actions-link-login", onClick: () => setState("login") }, translation.candidateWidgetChangeProfile)));
            case "recover":
                return (React.createElement(React.Fragment, null,
                    translation.candidateWidgetAlredySignedUp,
                    " ",
                    React.createElement("a", { className: "tms-candidate-widget-actions-link-login", onClick: () => setState("login") }, translation.candidateWidgetChangeProfile)));
            case "login":
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", null,
                        translation.candidateWidgetLostPassword,
                        " ",
                        React.createElement("a", { className: "tms-candidate-widget-actions-link-recover-password", onClick: () => setState("recover") }, translation.candidateWidgetGetNewPassword)),
                    React.createElement("div", null,
                        translation.candidateWidgetNoCredentials,
                        " ",
                        React.createElement("a", { className: "tms-candidate-widget-actions-link-register", onClick: () => setState("register") }, translation.candidateWidgetRegisterHere))));
            case "loggedin":
                return (React.createElement("div", null,
                    React.createElement("a", { className: "tms-candidate-widget-actions-link-user-profile", href: "/user", target: "_blank" }, translation.candidateWidgetLoggedInCopy)));
            case "success":
                return null;
            default:
                return null;
        }
    };
    // we dont need a button in the success state.
    if (state === "success") {
        return null;
    }
    if (state === "loggedin") {
        return (React.createElement("div", { className: "tms-candidate-widget-actions" },
            React.createElement("div", null, menuLinks())));
    }
    return (React.createElement("div", { className: "tms-candidate-widget-actions" },
        React.createElement("div", null,
            React.createElement("input", { className: `tms-candidate-widget-actions-submit-button ${handleCustomClass("submitButton") || ""}`, ref: submitButtonRef, type: "submit", value: setButtonLabel() || "" })),
        React.createElement("div", null, menuLinks())));
}
export default Actions;
